import React from 'react'

export default function Button({ disabled, text, className }) {
    return (
        <div className="mt-4">
            <button className={`btn btn-${className} btn-block waves-effect waves-light`} type="submit" disabled={disabled}>{text}</button>
        </div>
    );
}